export default function Button({ children, onClick }) {
  return (
    <button className="bg-[#ffa723] p-2 text-white" onClick={onClick}>
      {children}
    </button>
  );
}
